'use strict';
import { SidebarSortingFilters } from '../types/sortingFilters';

export const defaultFilter: SidebarSortingFilters = {
  capitalization: [0, 0],
  investment: [0, 0],
  onlyFavorites: false,
  tvlOrder: null,
  volume: [0, 0],
};
